export default __webpack_public_path__ + "fe97c60bd9f6b50afac35d73f9955fce.png";